export function createGameHeader(scene) {

    const width = scene.cameras.main.width;

    const logo = scene.add.image(width / 2, 105, 'homersLogo');

    logo.setOrigin(0.5).setDepth(50);

    // Keep the logo responsive without stretching it.
    const maxWidth = Math.min(width * 0.48, 190);

    if (logo.width > maxWidth) {
        logo.setDisplaySize(
            maxWidth,
            logo.height * (maxWidth / logo.width)
        );
    }

    scene.gameHeaderLogo = logo;

    return logo;
}